import { FC } from 'react'
import { Row, Col, Text, Breadcrumb } from '@/client/components'
import * as S from './styles'
import { FeaturedProps } from '../types'
import { PostTag } from '../Components'
import { useGetMedia } from '@/client/hooks'

export const Featured: FC<FeaturedProps> = ({
  breadcrumb,
  name,
  description,
  tags,
  banner_image,
  author,
  featured_media,
  seo
}) => {
  const { data, isFetching } = useGetMedia(featured_media || undefined)
  const getDate = (articleDate?: string) => {
    if (!articleDate) {
      return new Date().toISOString().split('T')[0]
    }

    const parsed = new Date(articleDate)

    if (isNaN(parsed.getTime())) {
      return new Date().toISOString().split('T')[0]
    }

    return parsed.toISOString().split('T')[0]
  }

  return (
    <S.Featured $imageUrl={banner_image['url']}>
      <Row>
        <Col>
          <Breadcrumb pages={breadcrumb} inverse={true} />
        </Col>
      </Row>
      <Row style={{ height: '100%' }}>
        <Col>
          <S.MainFeatured>
            <S.FullFeatured>
              {name && (
                <Text
                  as='h1'
                  size='h3'
                  family='heading'
                  style={{ margin: '0' }}
                  weight='bold'
                  itemProp='name'
                  color='inverse'
                  className='header_text'
                >
                  {name}
                </Text>
              )}

              {description && (
                <Text
                  as='p'
                  color='inverse'
                  size='md'
                  family='heading'
                  weight='medium'
                  margin='0'
                  itemProp='description'
                  className='header_description'
                >
                  {description}
                </Text>
              )}

              {author && (
                <S.PostMeta>
                  <Text as='p' size='md' color='inverse' family='heading' weight='medium' itemProp='description'>
                    {author} • {seo?.date ? getDate(seo.date) : 'No date'}
                  </Text>
                </S.PostMeta>
              )}

              <S.PostTagWrapper>{tags && tags.length > 0 && <PostTag tags={tags} />}</S.PostTagWrapper>
            </S.FullFeatured>
          </S.MainFeatured>
        </Col>
      </Row>
    </S.Featured>
  )
}
